<!-- notification-bell.component.html -->
<div class="notif-bell-wrapper" [class.open]="isOpen">

  <!-- ── Bell Trigger ─────────────────────────────────── -->
  <button class="bell-btn" [class.shaking]="isShaking" [attr.aria-label]="'Notifications, ' + unreadCount + ' unread'"
    [attr.aria-expanded]="isOpen" (click)="toggleDropdown()" type="button">
    <mat-icon class="bell-icon">notifications</mat-icon>

    @if (unreadCount > 0) {
    <span class="badge" [class.badge--pulse]="isShaking" role="status">
      {{ badgeLabel }}
    </span>
    }
  </button>

  <!-- ── Dropdown Panel ───────────────────────────────── -->
  <div class="notif-panel" role="dialog" aria-label="Notifications" [class.notif-panel--visible]="isOpen">
    <!-- Header -->
    <div class="panel-header">
      <div class="panel-title">
        <span class="panel-title__text">Notifications</span>
        @if (unreadCount > 0) {
        <span class="panel-title__pill">{{ unreadCount }} new</span>
        }
      </div>
      @if (unreadCount > 0) {
      <button class="mark-all-btn" (click)="onMarkAllRead($event)" type="button">
        <mat-icon>done_all</mat-icon>
        Mark all read
      </button>
      }
    </div>

    <div class="panel-divider"></div>

    <!-- Body -->
    <div class="panel-body">

      <!-- Loading skeleton -->
      @if (isLoading) {
      <div class="skeleton-list">
        @for (i of [1,2,3]; track i) {
        <div class="skeleton-item">
          <div class="skeleton-icon"></div>
          <div class="skeleton-lines">
            <div class="skeleton-line skeleton-line--title"></div>
            <div class="skeleton-line skeleton-line--body"></div>
            <div class="skeleton-line skeleton-line--time"></div>
          </div>
        </div>
        }
      </div>
      }

      <!-- Empty state -->
      @if (!isLoading && notifications.length === 0) {
      <div class="empty-state">
        <div class="empty-state__icon">
          <mat-icon>notifications_none</mat-icon>
        </div>
        <p class="empty-state__title">All caught up!</p>
        <p class="empty-state__sub">No notifications yet</p>
      </div>
      }

      <!-- Notification list -->
      @if (!isLoading && notifications.length > 0) {
      <ul class="notif-list" role="list">
        @for (notif of notifications; track notif.id) {
        <li class="notif-item" [class.notif-item--unread]="!notif.isRead"
          [class.notif-item--clickable]="!!notif.resourceLink" role="listitem" (click)="onNotificationClick(notif)">
          <!-- Color bar -->
          <span class="notif-item__bar" [attr.data-color]="getNotifColor(notif.type)"></span>

          <!-- Icon -->
          <div class="notif-item__icon" [attr.data-color]="getNotifColor(notif.type)">
            <mat-icon>{{ getNotifIcon(notif.type) }}</mat-icon>
          </div>

          <!-- Content -->
          <div class="notif-item__content">
            <p class="notif-item__title">{{ notif.title }}</p>
            <p class="notif-item__message">{{ notif.message }}</p>
            <span class="notif-item__time">
              <mat-icon class="time-icon">schedule</mat-icon>
              {{ formatTime(notif.createdAt) }}
            </span>
          </div>

          <!-- Actions -->
          <div class="notif-item__actions">
            @if (!notif.isRead) {
            <span class="unread-dot" title="Unread"></span>
            }
            <button class="delete-btn" (click)="onDelete($event, notif.id)" type="button" title="Dismiss"
              aria-label="Dismiss notification">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </li>
        }
      </ul>
      }
    </div>

    <!-- Footer -->
    <div class="panel-divider"></div>
    <div class="panel-footer">
      <button class="view-all-btn" (click)="viewAll()" type="button">
        View all notifications
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

  </div>

  <!-- Backdrop (mobile) -->
  @if (isOpen) {
  <div class="notif-backdrop" (click)="closeDropdown()" aria-hidden="true"></div>
  }
</div>